import React from "react";
import Img from 'react-image'

import {
  isMobile,
} from "react-device-detect";

const _ = require('lodash');

let pics = gon.pics;

export const Pic = ({css, type, post}) => {
  let posfix;
  if (isMobile)
    posfix = type === "list" ? "tr:w-100,h-75,f-center" : "tr:w-400,h-300,f-center";
  else
    posfix = type === "list" ? "tr:w-200,h-150,f-center" : "tr:w-600,h-450,f-center";

  let tag = _.find(post.tags, t => pics[t]) || "";
  let tagPics = pics[tag];
  let pic = tagPics[post.id % tagPics.length];

  let src = `https://ik.imagekit.io/fridmanwork/pics/${pic.id}/${posfix}'/`;
  let alt = pic.alt;
  // let src = "/pics/" + images[pos];

  return <figure className={`image ${css}`}><Img loading="lazy" src={src} alt={alt} title={alt} key={Math.random()}/></figure>;
};

